import { useState } from 'react';
import { ApplicationList } from '../../components/ApplicationList';
import { BorrowerFundraisingDetail } from '../../components/BorrowerFundraisingDetail';

export const BorrowerView = () => {
  const [selectedApplication, setSelectedApplication] = useState(null);

  return !selectedApplication ? (
    <ApplicationList setSelectedApplication={setSelectedApplication} />
  ) : (
    <BorrowerFundraisingDetail
      selectedApplication={selectedApplication}
      onBack={() => setSelectedApplication(null)}
    />
  );
};